import { LadiesMain } from "@modules/global/ladies-main"
import { initializeVideos, pauseVideos } from "./gallery-videos"

export const sharedGalleryModal = (): HTMLElement | null =>
    document.querySelector("#shared-gallery.modal") as HTMLElement | null
export const isGalleryOpen = (): boolean =>
    document.body.classList.contains("modal-open") && (sharedGalleryModal()?.classList.contains("in") || false)

let sharedGalleryImageElement: HTMLElement | null = null
let sharedGalleryTextElement: HTMLElement | null = null

export function initializeSharedModal(): void {
    const modal: HTMLElement | null = sharedGalleryModal()
    if (!modal) {
        return
    }

    sharedGalleryImageElement = modal.querySelector("#shared-gallery-image")
    sharedGalleryTextElement = modal.querySelector(".gallery-info .gallery-text")

    const jqueryGalleryModal = $(modal)

    if (modal?.classList.contains("in")) {
        document.documentElement.classList.add("modal-open")
        initializeVideos()
    } else {
        jqueryGalleryModal.one("show.bs.modal", (): void => {
            document.documentElement.classList.add("modal-open")
            initializeVideos()
        })
    }

    jqueryGalleryModal.on("show.bs.modal", (): void => {
        document.documentElement.classList.add("modal-open")
    })

    jqueryGalleryModal.on("hide.bs.modal", (): void => {
        document.documentElement.classList.remove("modal-open")
        LadiesMain.removeHashtagFromUrl("gallery")
        pauseVideos()
    })

    window.addEventListener("keyup", (event: KeyboardEvent): void => {
        if (event.key === "Escape" && isGalleryOpen()) {
            closeSharedModal()
        }
    })

    modal.querySelector(".gallery-image-container")?.addEventListener("click", (): void => {
        if (isGalleryOpen()) {
            closeSharedModal()
        }
    })
}

export function openSharedModal(galleryLink: HTMLElement): void {
    const modal: HTMLElement | null = sharedGalleryModal()
    if (!modal || !sharedGalleryImageElement) {
        return
    }

    sharedGalleryImageElement.setAttribute("src", galleryLink.getAttribute("href") || "")

    if (sharedGalleryTextElement) {
        sharedGalleryTextElement.innerText = galleryLink.dataset.heading || ""
    }

    requestAnimationFrame(() => {
        $(modal).modal("show")
    })
}

export function closeSharedModal(): void {
    const modal: HTMLElement | null = sharedGalleryModal()
    if (!modal) {
        return
    }

    requestAnimationFrame(() => {
        $(modal).modal("hide")
    })
}
